import { normalizeFilters } from "../../../shared/lib/normalizeFilters";

export const absenceKeys = {
  all: ["absences"] as const,
  lists: () => [...absenceKeys.all, "list"] as const,
  list: (filters?: Record<string, unknown>) =>
    [...absenceKeys.lists(), normalizeFilters(filters)] as const,
  detail: (id: number) => [...absenceKeys.all, "detail", id] as const,
};
